import Vue from "vue";
import App from "./App.vue";
import router from "./router";
import store from "./store";
import ElementUI from 'element-ui';
import {
  Message
} from 'element-ui';
import 'element-ui/lib/theme-chalk/index.css';
// 全局样式表
import './assets/css/golbal.css'
import './assets/css/font.css'
import axios from 'axios'
import createAuthRefreshInterceptor from 'axios-auth-refresh';
// 引入插件  高亮显示文字
import highlight from 'v-highlight-component';

axios.defaults.baseURL = process.env.VUE_APP_BASE_URL

// 配置组件的默认类名和样式
Vue.use(highlight, {
  class: 'MOONCOM zhangsan',
  style: {
    color: '#ffffff'
  }
});
Vue.prototype.$http = axios
// 设置请求拦截器，为请求对象添加token，这是后续权限api要求的
Vue.prototype.$http.interceptors.request.use(req => {
  // req就是请求对象
  if (sessionStorage.getItem('token')) {
    req.headers.Authorization = "Bearer " + sessionStorage.getItem('token');
  }
  // 最后必须返回req
  return req;
}, function (error) {
  // 对请求错误做些什么
  ElementUI.Message({
    message: error,
    type: 'error'
  });
  return Promise.reject(error);
});
// 设置响应拦截器，判断返回的状态码
Vue.prototype.$http.interceptors.response.use(response => {
      return Promise.resolve(response);
  },
  //  服务器状态码不是200的情况
  error => {
    if (error.response.status) {
      console.log(error.response.status);
      switch (error.response.status) {
        case 451:
          Message({
            showClose: true,
            message: '内容涉及敏感信息，请重新输入！',
            type: 'warning'
          });
          break;
        default:
          break;
      }
    }
    return Promise.reject(error);
  }
)
const refreshAuthLogic = failedRequest => {

  const instance = axios.create();
  return new Promise(resolve => {
    new TencentCaptcha(process.env.VUE_APP_TENCENT_CAPTCHA_APP_ID, async response => {
      if (response.ret === 0) {
        await instance.post("/auth/captcha", {
          ticket: response.ticket,
          randStr: response.randstr,
        }).then(res => {
          sessionStorage.setItem("token", res.data.accessToken.tokenValue);
          failedRequest.response.config.headers['Authorization'] = 'Bearer ' + res.data.accessToken.tokenValue;
        }).then(() => resolve());
      } else {
        // this.$message.error("")
        ElementUI.Message({
          message: '请完成滑块验证',
          type: 'error'
        });
      }
    }).show()
  });
}
createAuthRefreshInterceptor(axios, refreshAuthLogic);
// 组件注册
Vue.use(highlight);
Vue.use(ElementUI);
Vue.config.productionTip = false;

new Vue({
  router,
  store,
  render: h => h(App)
}).$mount("#app");